<script>
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const PRODUCT_PROMOTION_CLICK = analyticsUtilities.events.PRODUCT_PROMOTION_CLICK;

	module.exports = {
		props: {
			applyFilters: {
				default: function () {
					return;
				}
			}
		},
		modelData: ['gcAddon'],
		methods: {
			filterByPairedText(loc) {
				fireEvent(PRODUCT_PROMOTION_CLICK, { loc });
				this.applyFilters({ id: 'P' });
			},
			onBlurbTextClick(loc) {
				fireEvent(PRODUCT_PROMOTION_CLICK, { loc });
			}
		}
	};
</script>
<template>
	<div class="promotion-panel product-promotion-panel paired-text">
		<div class="promotion-title">
			<h2>Paired Texts</h2>
			<a
				href="javascript:void(0)"
				@click="filterByPairedText('PAIREDTEXT_BROWSE')">
				See All
				<i
					class="fa-solid fa-arrow-right-long"
					aria-hidden="true"></i>
			</a>
		</div>
		<div class="promotion-blurb">
			Engage students in deeper thinking!
			<a
				href="/teacher-guide/paired-texts.html"
				@click="onBlurbTextClick('pt-promo-tg')"
				:target="gcAddon ? '_blank' : '_self'">
				Paired texts
			</a>
			are two passages about a common topic, theme, or literary element.
			<a
				href="/teacher-guide/spanish-english-paired-texts.html"
				@click="onBlurbTextClick('pet-promo-tg')"
				:target="gcAddon ? '_blank' : '_self'">
				Spanish-English Paired Texts
			</a>
			are a Spanish passage that builds background knowledge and a paired English passage about a similar topic. All paired texts have a question set to
			help students draw important connections and deepen reading comprehension.
		</div>
	</div>
</template>
